export default __webpack_public_path__ + "static/media/chdtu.e09e317f.jpg";